import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dialog } from 'primereact/dialog';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import CarryForwardStrengths from '../carryForward/CarryForwardStrengths';
import { useGetCoachingCoachingStrengthQuery } from '../strengthSlice';
import '../strengths.scss';
import { SearchStrengthRequest } from '../types';
import { CoachingEntityTypes, CoachingTabs } from '../../../../utils/typeConstants';
import { ROLES } from '../../../../constants';
import { selectCurrentUserManagerLevel } from '../../../../pages/login/authSlice';

export type HeaderProps = {
    receiverId: string;
    authorId: string;
    month?: number;
    year?: number;
    setStrengthList: (strengths: any) => void;
    OnViewState: (viewState: string) => void;
    via?: number;
    coachingEntityId?: number;
};
const Header = ({
    receiverId,
    authorId,
    year,
    month,
    setStrengthList,
    OnViewState, via, coachingEntityId
}: Readonly<HeaderProps>) => {
    const [date, setDate] = useState(new Date());
    const [inputMonth, setMonth] = useState<number | undefined>(undefined);
    const [inputYear, setYear] = useState<number | undefined>(undefined);
    const [carryDialog, setCarryDialog] = useState(false);
    const userManagerLevel = useSelector(selectCurrentUserManagerLevel);
    const initParams = () => {
        // add keys only if value exists
        const params: SearchStrengthRequest = {
            employeeNumber: receiverId,
        };

        if (authorId) {
            params.authorEmployeeNumber = authorId;
        }

        if (month && year && (inputMonth === undefined || inputYear === undefined)) {
            setMonth(month);
            setYear(year);
        }

        params.month = inputMonth;
        params.year = inputYear;

        return params;
    };

    const handleButtonClick = () => {
        if (authorId === receiverId) {
            toast.warning('You cannot create your own strengths');
        } else {
            setCarryDialog(true);
        }
    };

    const handleNewStrength = () => {
        if (authorId === receiverId) {
            toast.warning('You cannot create your own strengths');
        } else {
            OnViewState('new');
        }
    };

    const onHide = () => {
        setCarryDialog(false);
    };

    const { data: strengths } = useGetCoachingCoachingStrengthQuery(initParams());
    useEffect(() => {
        if (via === CoachingTabs.CoachingInsights) {
            setStrengthList(strengths?.data?.filter((item: any) => item.coaching_entity_id === coachingEntityId && item.coaching_entity_type_id === CoachingEntityTypes.CoachingInsights) || []);
        }
        else
            setStrengthList(strengths?.data || []);
    }, [strengths?.data]);

    const DateOnChange = (e: any) => {
        setMonth(e.value.getMonth() + 1);
        setYear(e.value.getFullYear());
    };

    useEffect(() => {
        if (month && year) {
            const date = new Date(year, month - 1);
            setDate(date);
            setMonth(month);
            setYear(year);
        }
    }, []);

    return (
        <>
            <div className="header-coaching mb-3">
                <h3 className="headerText">Strengths</h3>
                <div className="flexButtons">
                    {strengths?.data?.length === 0 && (
                        <div>
                            <Button
                                label="Carry Forward"
                                className="btn-secondary me-2"
                                onClick={handleButtonClick}
                            />
                        </div>
                    )}
                    {(via !== CoachingTabs.CoachingInsights || !ROLES.Agents.includes(userManagerLevel)) && (
                        <div>
                            <Button
                                label="New Strength"
                                icon="btnPlusIcon"
                                className="btn-primary me-2"
                                onClick={handleNewStrength}
                            />
                        </div>
                    )}
                </div>
            </div>
            <div className="col-md-3 mb-3">
                <div className="content">
                    <label htmlFor="selectmonth">Month</label>
                    <Calendar
                        id="selectmonth"
                        value={date}
                        onChange={DateOnChange}
                        view="month"
                        maxDate={new Date()}
                        showIcon
                        className="custom-calendar"
                        dateFormat="MM, yy"
                    />
                </div>
            </div>
            <div style={{ textAlign: 'end' }}>
                <span style={{ fontWeight: 400, lineHeight: '16.8px', fontSize: '14px' }}>
                    Each month, a minimum of 1 Strength is required. However, we strongly advise having at
                    least 3 Strengths each month
                </span>
            </div>
            <div className="splitSection" />
            <Dialog
                header="Strengths"
                visible={carryDialog}
                style={{ width: '50vw' }}
                onHide={() => setCarryDialog(false)}
            >
                <CarryForwardStrengths
                    onHide={onHide}
                    authorId={authorId}
                    receiverId={receiverId}
                    inputMonth={inputMonth}
                    inputYear={inputYear}
                />
            </Dialog>
        </>
    );
};

export default Header;
